export default __webpack_public_path__ + "static/media/block3.938522f7.webp";